import React from "react";
import { FaSortUp, FaSortDown } from "react-icons/fa";
import { useState } from "react";

const TableHeader = ({ listInfo , setListInfo  }) => {

    const [sortOrderRelease, setSortOrderRelease] = useState("asc");
    const [sortOrderUpdated, setSortOrderUpdated] = useState("asc");
    const [sortOrderInstall, setSortOrderInstall] = useState("asc");
    const [sortOrderRevenue, setSortOrderRevenue] = useState("asc"); 
    const [sortOrderDownload, setSortOrderDownload] = useState("asc");
  
    const handleSortRelease = () => {
      const newSortOrder = sortOrderRelease === "asc" ? "desc" : "asc";
      setSortOrderRelease(newSortOrder);
    
      const sortedList = [...listInfo].sort((a, b) => {
        const dateA = convertDate(a.release_date);
        const dateB = convertDate(b.release_date);
        return newSortOrder === "asc" ? dateA - dateB : dateB - dateA;
      });
    
      setListInfo(sortedList);
    };
    
    const handleSortUpdated = () => {
      const newSortOrder = sortOrderUpdated === "asc" ? "desc" : "asc";
      setSortOrderUpdated(newSortOrder);
    
      const sortedList = [...listInfo].sort((a, b) => {
        const dateA = convertDate(a.update_date);
        const dateB = convertDate(b.update_date)
        return newSortOrder === "asc" ? dateA - dateB : dateB - dateA;
      });
    
      setListInfo(sortedList);
    };

    const handleSortInstall = () => {
      setSortOrderInstall(sortOrderInstall === "asc" ? "desc" : "asc");
      const sortedList = [...listInfo].sort((a, b) => {
        const aMin = convertToNumber(a.installs.split(" - ")[0]);
        const bMin = convertToNumber(b.installs.split(" - ")[0]);
        return sortOrderInstall === "asc" ? aMin - bMin : bMin - aMin;
      });
      setListInfo(sortedList);
    };

    const handleSortRevenue = () => {
      const newSortOrder = sortOrderRevenue === "asc" ? "desc" : "asc";
      setSortOrderRevenue(newSortOrder);
    
      const sortedList = [...listInfo].sort((a, b) => {
        const valueA = convertRevenueToNumber(a.revenue);
        const valueB = convertRevenueToNumber(b.revenue);
    
        return newSortOrder === "asc" ? valueA - valueB : valueB - valueA;
      });
    
      setListInfo(sortedList);
    };

    const handleSortDownload = () => {
      const newSortOrder = sortOrderDownload === "asc" ? "desc" : "asc";
      setSortOrderDownload(newSortOrder);
    
      const sortedList = [...listInfo].sort((a, b) => {
        const valueA = convertDownloadToNumber(a.download);
        const valueB = convertDownloadToNumber(b.download);
    
        return newSortOrder === "asc" ? valueA - valueB : valueB - valueA;
      });   
      setListInfo(sortedList);
    };

    const convertDownloadToNumber = (str) => {
      if (!str) return 0;
      
      str = str.replace(/[<>\$,]/gi, "").trim(); // Xóa ký tự đặc biệt
      
      let multiplier = 1;
      if (str.toLowerCase().includes("k")) multiplier = 1000;
      if (str.toLowerCase().includes("m")) multiplier = 1000000;
    
      return parseFloat(str) * multiplier;
    };

    const convertRevenueToNumber = (str) => {
      if (!str) return 0;
      str = str.replace(/[$,<]/gi, "").trim(); // Xóa ký tự $, <, dấu phẩy
    
      let multiplier = 1;
      if (str.toLowerCase().includes("k")) multiplier = 1000;
      if (str.toLowerCase().includes("m")) multiplier = 1000000;
    
      return parseFloat(str) * multiplier;
    };

    // Hàm chuyển đổi "1M" -> 1000000, "500K" -> 500000
    const convertToNumber = (str) => {
      const value = parseFloat(str);
      return str.includes("M") ? value * 1_000_000 :
            str.includes("K") ? value * 1_000 :
            value;
    };
  
    // Chuyển đổi từ "dd/mm/yyyy" → "yyyy-mm-dd" (ISO format)
    const convertDate = (dateStr) => {
      const [day, month, year] = dateStr.split("/").map(Number);
      return new Date(year, month - 1, day); // Tháng trong JavaScript bắt đầu từ 0
    };



    return (
        <thead>
          <tr className="bg-blue-500 text-white">
              <th className="p-2 border border-gray-300">No</th>
              <th className="p-2 border border-gray-300">Icon</th>
              <th className="p-2 border border-gray-300">Name</th>
              <th className="p-2 border border-gray-300">Package Name</th>
              <th className="p-2 border border-gray-300 cursor-pointer text-center">
              <div className="inline-flex items-center gap-1" onClick={handleSortRelease}>
                  Release Date {sortOrderRelease === "asc" ? <FaSortUp /> : <FaSortDown />}
              </div>
              </th>
              <th className="p-2 border border-gray-300 cursor-pointer text-center">
              <div className="inline-flex items-center gap-1" onClick={handleSortUpdated}>
                  Last Updated {sortOrderUpdated === "asc" ? <FaSortUp /> : <FaSortDown />}
              </div>
              </th>
              <th className="p-2 border border-gray-300 cursor-pointer text-center">
                <div className="inline-flex items-center gap-1" onClick={handleSortInstall}>
                  Install Range {sortOrderInstall === "asc" ? <FaSortUp /> : <FaSortDown />}
                </div>
              </th>
              <th className="p-2 border border-gray-300 cursor-pointer text-center">
                <div className="inline-flex items-center gap-1" onClick={handleSortRevenue}>
                  Revenue {sortOrderRevenue === "asc" ? <FaSortUp /> : <FaSortDown />}
                </div>
              </th>
              <th className="p-2 border border-gray-300 cursor-pointer text-center">
                <div className="inline-flex items-center gap-1" onClick={handleSortDownload}>
                  Download {sortOrderDownload === "asc" ? <FaSortUp /> : <FaSortDown />}
                </div>
              </th>

              <th className="p-2 border border-gray-300">CHPlay</th>
              <th className="p-1 border border-gray-300">Sensortower</th>
              <th className="p-2 border border-gray-300">AppBrain</th>
              <th className="p-2 border border-gray-300">Delete</th>
          </tr>
        </thead>
    );
};

export default TableHeader;
